import { render, staticRenderFns } from "./TeamMembersComponent.vue?vue&type=template&id=5e735b8d&scoped=true&lang=html&"
import script from "./TeamMembersComponent.vue?vue&type=script&lang=js&"
export * from "./TeamMembersComponent.vue?vue&type=script&lang=js&"
import style0 from "./TeamMembersComponent.vue?vue&type=style&index=0&id=5e735b8d&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e735b8d",
  null
  
)

export default component.exports